import React ,{useEffect, useState} from "react";
import * as s from "./Home.styles";
import { Formik, Form } from "formik";
import FormikControl from "../../../components/shared/inputs/FormikControl";
import LineProgressBar from "../../../components/shared/lineProgressBar/LineProgressBar";
import * as Yup from "yup";
import { useParams, useHistory, useLocation } from "react-router-dom";
import * as actions from "../../../store/actions/index";
import { useDispatch, useSelector } from "react-redux";
const Home = () => {
  let dispatch = useDispatch();
  let userName = useSelector((state) => state.auth.userName)
  let userId = useSelector((state) => state.auth.userId)
  let clientProjects = useSelector((state) => state.milestone.allProjects)
 
  let projectMilestones = useSelector((state) => state.milestone.milestones);
  

  let milestoneLoading = useSelector((state) => state.milestone.loading); 
  let milestoneTotal = useSelector((state) => state.milestone.count);
  let milesstoneTotalDone = useSelector((state) => state.milestone.totalOfDone);
  let percentage = useSelector((state) => state.milestone.percentage)
 

  useEffect(() => {
    dispatch(actions.authCheckState());
    dispatch(actions.fetchAllProjects())
    
  } , [])

  const getTask = (pr_id) => {
    dispatch(actions.fetchMilestones(pr_id));
    dispatch(actions.SelectProjectId(pr_id));
    
  }
  

const [optionValue , setOptionValue] = useState("");
  const initialValues = {
    selectOption: "",
  };
  const validationSchema = Yup.object({});

  let tasks = <s.Span>Please Select Project</s.Span>;
 
  if (projectMilestones !== null && milestoneLoading === false) {
    tasks = (
      <s.DisplayTasks>
        {projectMilestones.length !== 0 && optionValue &&
          projectMilestones.map((element) => {
            return (
              <s.SingleTaskContainer key={element.ts_id}>
                <s.displayColor isTaskDone={element.done}></s.displayColor>
                <s.NameOfTask>{`${element.name} (${element.description})`}</s.NameOfTask>
                
              </s.SingleTaskContainer>
            );
          })}
      </s.DisplayTasks>
    );
  }
  return (
    <s.MainContainer>
      <s.HomeContainer>
      <s.H1>Hi Client ({userName}),</s.H1>
        <s.SelectContainer>
        
        <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  // onSubmit={onSubmit}
                >
                  {(formik) => (
                    <Form style={{ width: "270px" }}>
                      <FormikControl
                        control="select"
                        name="selectOption"
                        onChange={(e) => {
                          
                          getTask(e.target.value);
                          formik.setFieldValue("selectOption", e.target.value);
                          setOptionValue(e.target.value)
                        }}
                        value={formik.values.selectOption}
                      >
                        <option  value="">SELECT PROJECT</option>
                        {clientProjects &&
                          clientProjects.map((option) => {
                            return (
                              <option key={option.pr_id} value={option.pr_id}>
                                {option.name}
                              </option>
                            );
                          })}
                        
                      </FormikControl>
                    </Form>
                  )}
                </Formik>
                </s.SelectContainer>
                <s.TaskContainer>
                <s.ProgressContainer>
                  <LineProgressBar complete ={percentage} />
                  <s.H1>{`${percentage}%`}</s.H1>
                </s.ProgressContainer>
                          {tasks}
                </s.TaskContainer>
      </s.HomeContainer>
      <s.NotificationContainer>
        
        <s.Tasks>
        <s.H2>Notifications for tasks</s.H2>
          <s.Task>
          
                <s.TaskName><s.displayColor isTaskDone = {false}></s.displayColor>This is some text inside of a div block</s.TaskName>
                <s.TaskDate>Monday 5/24/21</s.TaskDate>
          </s.Task>
          <s.Task>
          
                <s.TaskName><s.displayColor isTaskDone = {false}></s.displayColor>This is some text inside of a div block</s.TaskName>
                <s.TaskDate>Monday 5/24/21</s.TaskDate>
          </s.Task>
          <s.Task>
          
                <s.TaskName><s.displayColor isTaskDone = {false}></s.displayColor>This is some text inside of a div block</s.TaskName>
                <s.TaskDate>Monday 5/24/21</s.TaskDate>
          </s.Task>
          <s.Task>
          
                <s.TaskName><s.displayColor isTaskDone = {false}></s.displayColor>This is some text inside of a div block</s.TaskName>
                <s.TaskDate>Monday 5/24/21</s.TaskDate>
          </s.Task>
          <s.Task>
          
                <s.TaskName><s.displayColor isTaskDone = {false}></s.displayColor>This is some text inside of a div block</s.TaskName>
                <s.TaskDate>Monday 5/24/21</s.TaskDate>
          </s.Task>
          <s.Task>
          
                <s.TaskName><s.displayColor isTaskDone = {false}></s.displayColor>This is some text inside of a div block</s.TaskName>
                <s.TaskDate>Monday 5/24/21</s.TaskDate>
          </s.Task>
          
        
        </s.Tasks>

        <s.TasksCreate>
          <s.H1>Tasks created</s.H1>
          <s.TaskInfo> projectName taskCreated for this client</s.TaskInfo>
          <s.TaskInfo> projectName taskCreated for this client</s.TaskInfo>
          <s.TaskInfo> projectName taskCreated for this client</s.TaskInfo>
          <s.TaskInfo> projectName taskCreated for this client</s.TaskInfo>
          <s.TaskInfo> projectName taskCreated for this client</s.TaskInfo>
        </s.TasksCreate>
      </s.NotificationContainer>
    </s.MainContainer>
  );
};

export default Home;
